import { useCallback } from "react";
import { container } from "tsyringe";
import { XMarkIcon } from "@heroicons/react/20/solid";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import Modal from "components/elements/Modal";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import UpcomingActionResponseResource from "common/resources/Project/Config/UpcomingAction/UpcomingActionResponseResource";
import { useProjectId } from "hooks/useProjectId";
import UpcomingActionService from "services/projects/UpcomingActionService";
import { translateISO369 } from "utils/I18nText";
import classes from "./classes.module.scss";

type IProps = {
	action: UpcomingActionResponseResource;
	isOpen: boolean;
	onClose: () => void;
	onDeleted: (action: UpcomingActionResponseResource) => void;
};

const upcomingActionService = container.resolve(UpcomingActionService);

export default function DeleteActionModal(props: IProps) {
	const { projectId } = useProjectId();

	const onDeleteAction = useCallback(() => {
		upcomingActionService.delete(projectId, props.action.id).then(() => props.onDeleted(props.action));
	}, [projectId, props]);

	return (
		<Modal isOpen onClose={props.onClose} className={classes["root"]}>
			<div className={classes["header"]}>
				<Typography type="p" size="large" weight="bold">
					{I18n.asset.pages.professional_space.tabs.actions.delete_action_modal.title}
				</Typography>
				<XMarkIcon className={classes["icon"]} onClick={props.onClose} />
			</div>

			<div className={classes["text-container"]}>
				<Typography type="p">
					{I18n.trslt(I18n.asset.pages.professional_space.tabs.actions.delete_action_modal.text_1, { name: translateISO369(props.action.title) ?? "undefined" })}
				</Typography>
				<Typography type="p">{I18n.asset.pages.professional_space.tabs.actions.delete_action_modal.text_2}</Typography>
			</div>

			<div className={classes["buttons-container"]}>
				<Button variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} onClick={props.onClose}>
					{I18n.asset.pages.professional_space.tabs.actions.delete_action_modal.cancel}
				</Button>
				<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} onClick={onDeleteAction}>
					{I18n.asset.pages.professional_space.tabs.actions.delete_action_modal.confirm}
				</Button>
			</div>
		</Modal>
	);
}
